import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['answer']

  toggle() {
    this.answerTargets.forEach(element => {
      if (element.getAttribute('data-correct') === 'true') {
        element.classList.toggle('bg-success-100')
        element.classList.toggle('border-success-500')
        element.classList.toggle('border-gray-200')
      }
    });
  }
}
